import {Button} from "react-bootstrap";
import React from "react";
import StorageManager from "../../services/StorageManager.service";
import {useNavigate} from "react-router-dom";
import AppRoute from "../../utils/AppRoute";
import eventBus from "../../utils/EventBus";

const LogoutButton = () =>{

    const navigate = useNavigate();

    const handleLogout = (event) =>{
        event.preventDefault();

        StorageManager.clearUserInfo();
        eventBus.dispatch("userLogout");

        navigate(AppRoute.BASE)
    }

    return(
        <Button variant={'primary'} className={'px-5 fw-bold'} onClick={(e) => handleLogout(e)}>Logout</Button>
    )
}

export default LogoutButton;
